import { CgvVersionEntity, FilterCgvRequestParams, FilterCgvResponse } from '@smatchy/sdk';
import { ATextPutAgainToTheMember } from '../domain/a-new-version-of-the-terms-or-the-policy-is-put-to-the-member';

export class LoadCgvList {
  static readonly type = '[CGV] Load List';
  constructor(public params: FilterCgvRequestParams) {}
}

export class LoadCgvListSuccess {
  static readonly type = '[CGV] Load List Success';
  constructor(public response: FilterCgvResponse) {}
}

export class LoadCgvListFail {
  static readonly type = '[CGV] Load List Fail';
  constructor(public error: unknown) {}
}

/* ===== LAST VERSION ===== */
export class LoadLastCgvVersion {
  static readonly type = '[CGV] Load Last Version';
  constructor(public cgvId: string) {}
}

export class LoadLastCgvVersionSuccess {
  static readonly type = '[CGV] Load Last Version Success';
  constructor(
    /*
     * Optional: `theBodyOf` answers nothing when the response carries no body,
     * and the handler patches whatever arrives. Declaring a version always
     * present only stopped the dispatch from compiling.
     */
    public version: CgvVersionEntity | undefined,
  ) {}
}

export class LoadLastCgvVersionFail {
  static readonly type = '[CGV] Load Last Version Fail';
  constructor(public error: unknown) {}
}

/* ===== CHECK NEW VERSION ===== */
export class CheckNewCgvVersion {
  static readonly type = '[CGV] Check New Version';
  constructor() {}
}

export class CheckNewCgvVersionSuccess {
  static readonly type = '[CGV] Check New Version Success';
  constructor(
    /** Same: an answer with no body is an answer, and the handler reads it with `?.`. */
    public data:
      | {
          data: boolean;
          commission?: boolean;
          gcs?: boolean;
          /** Since 22/10/2026. An older API answers neither. */
          cgu?: boolean;
          privacy?: boolean;
        }
      | undefined,
  ) {}
}

export class CheckNewCgvVersionFail {
  static readonly type = '[CGV] Check New Version Fail';
  constructor(public error: unknown) {}
}
export class AcceptedNewCgv {
  static readonly type = '[CGV] AcceptedNewCgv';
  constructor(public userId: string) {}
}

export class AcceptedNewCgvSuccess {
  static readonly type = '[CGV] AcceptedNewCgvSuccess';
  constructor(public isAccepted: boolean) {}
}

export class AcceptedNewCgvFail {
  static readonly type = '[CGV] AcceptedNewCgvFail';
  constructor(public error: unknown) {}
}
export class AcceptedNewRefund {
  static readonly type = '[CGV] AcceptedNewRefund';
  constructor(public userId: string) {}
}

export class AcceptedNewRefundSuccess {
  static readonly type = '[CGV] AcceptedNewRefundSuccess';
  constructor(public isAccepted: boolean) {}
}

export class AcceptedNewRefundFail {
  static readonly type = '[CGV] AcceptedNewRefundFail';
  constructor(public error: unknown) {}
}

/**
 * The box ticked for a new version of the terms of use or of the privacy
 * policy. Throws when the API did not record it, so the window stays open.
 */
export class AcceptedNewLegalText {
  static readonly type = '[CGV] AcceptedNewLegalText';
  constructor(public text: ATextPutAgainToTheMember, public userId: string) {}
}

export class AcceptedNewGcs {
  static readonly type = '[CGV] AcceptedNewGcs';
  constructor(public userId: string) {}
}
